module.exports = __webpack_public_path__ + "static/media/testimonial-1.83f91612.png";